import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=7fe04a50&"
import script from "./EventDialog.vue?vue&type=script&lang=ts&"
export * from "./EventDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports